import { render, staticRenderFns } from "./Artikel.vue?vue&type=template&id=156c3c85"
import script from "./Artikel.vue?vue&type=script&lang=js"
export * from "./Artikel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports